module.exports = __webpack_public_path__ + "img/VueJS.5a5cf3f6.png";